export default "__VITE_ASSET__ac2a1ad8__"